//Updated ProcedureSave.tsx

import {
  Box,
  Button,
  Checkbox,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Tab,
  Tabs,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useMemo, useState, useContext } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SingleProcedureVisit from "./SingleProcedureVisit";
import CustomBreadcrumbs from "../../components/BreadcrumbsComponent/CustomBreadcrumbs";
import { useNavigate } from "react-router-dom";
import SettingsIcon from "@mui/icons-material/Settings";
import MultipleProcedureVisit from "./MultipleProcedureVisit";
import { useQuery } from "../../shared/CommonFunction";
import { EncryptDecryptService } from "../../services/common/EncryptionService";
import { PAGE_SIZE } from "../../services/common/const";
import { PreferencesContext } from "../../PreferenceContext";
import { AlertType } from "../../services/models/AlertType";
import {
  CreateConfiguration,
  GetSystemConfigurationById,
  UpdateConfiguration,
} from "../../services/SystemConfigurationService";
import SubProcedureVisit from "./SubProcedureVisit";

const PROCEDURE_TABS = [
  { label: "Single Visit", value: 0, code: "single-visit" },
  { label: "Multiple Visit", value: 1, code: "multiple-visit" },
  { label: "Sub Visit", value: 2, code: "sub-visit" },
];

interface Parameter {
  specialityId: string;
  consumerId: string;
  orgId: string;
  branchId: string;
  departmentId: string;
  pageIndex: number;
  pageSize: number;
  sortColumn: string;
  sortDirection: string;
  searchValue: string;
  tabType: number;
  mode: string;
}
// DEFAULT PARAMS -- ADD HERE IF YOU NEED NEW PARAMETER
const parameters: Parameter = {
  specialityId: "",
  consumerId: "",
  orgId: "",
  departmentId: "",
  branchId: "",
  pageIndex: 1,
  pageSize: PAGE_SIZE,
  sortColumn: "",
  sortDirection: "",
  searchValue: "",
  tabType: 0,
  mode: "DROPDOWN",
};
interface ReportConfigItem {
  systemConfigurationDetailId?: number;
  systemConfigurationId?: number;
  systemConfigurationDefaultId?: number;
  configModule?: string;
  configKey?: string;
  configKeyLabel?: string;
  configValue?: string;
  displayOrder?: number;
  isChecked?: boolean;
  mode?: string;
}

const ProcedureSave = (Props: any) => {
  const {
    isForPopUp = false,
    handleClosePopUp,
    code,
    isMemberProcedure = false,
    memberProcedureData = null,
    procedureName = null,
  } = Props;
  const addToExistingMultiple =
    memberProcedureData?.addToExistingMultiple === true;

  const edService = new EncryptDecryptService();
  const navigate = useNavigate();
  const { userContext, updateUserContext } = useContext(PreferencesContext);
  let urlParams = useQuery();
  let curRawProcedureId = urlParams.get("q");
  let currentTab = urlParams.get("t");
  let urlProcedureId = 0;
  let currTabType = 0;

  // if (curRawProcedureId !== null && curRawProcedureId !== undefined) {
  //   let decId = edService.decrypt(curRawProcedureId);
  //   if (decId !== "" && decId !== null && decId !== undefined) {
  //     urlProcedureId = +decId;
  //   }
  //   currTabType = PROCEDURE_TABS.find((x) => x.code === currentTab)?.value || 0;
  // } else {
  //   navigate("/not-found");
  // }

  if (!isForPopUp) {
    if (curRawProcedureId !== null && curRawProcedureId !== undefined) {
      let decId = edService.decrypt(curRawProcedureId);
      if (decId !== "" && decId !== null && decId !== undefined) {
        urlProcedureId = +decId;
      }
      currTabType =
        PROCEDURE_TABS.find((x) => x.code === currentTab)?.value || 0;
    }
  } else {
    if (isForPopUp) {
      urlProcedureId = 0;
    }
    currTabType = PROCEDURE_TABS.find((x) => x.code === currentTab)?.value || 0;
  }

  const [isLoading, setIsLoading] = useState<boolean>(true);
  // const [activeTab, setActiveTab] = useState(0);
  const [param, setParam] = useState({ ...parameters, tabType: currTabType });

  const [anchorEl, setAnchorEl] = React.useState<any>({
    for: "",
    target: null,
  });

  const isFieldEnabled = (configKey: string) => {
    return (
      reportConfigData?.find((item) => item.configKey === configKey)
        ?.isChecked ?? true
    );
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setParam({ ...param, tabType: newValue });
    if (!isForPopUp) {
      const tabCode =
        PROCEDURE_TABS.find((x) => x.value === newValue)?.code ||
        "general-info";
      navigate(
        {
          search: `?q=${encodeURIComponent(
            edService.encrypt(urlProcedureId) || "",
          )}&t=${tabCode}`,
        },
        { replace: true },
      );
    }
    // const tabCode =
    //   PROCEDURE_TABS.find((x) => x.value === newValue)?.code || "general-info";
    // navigate(
    //   {
    //     // pathname: teamMember.pathname,
    //     search: `?q=${encodeURIComponent(
    //       edService.encrypt(urlProcedureId) || "",
    //     )}&t=${tabCode}`,
    //   },
    //   { replace: true },
    // );
  };

  const handleBack = () => {
    navigate(-1);
    // if (isForPopUp) {
    //   handleClosePopUp("CLOSE");
    // } else {
    //   navigate(-1);
    // }
  };

  const handleSettingsOpen = (event: any, key: any) => {
    setAnchorEl({ target: event.currentTarget, for: key });
  };

  const handleSettingsClose = () => {
    setAnchorEl({ target: null, for: "" });
  };

  const handleToggleReportConfig = (index: number) => {
    setReportConfigData((prev) =>
      prev.map((item, i) =>
        i === index
          ? {
              ...item,
              isChecked: !item.isChecked,
            }
          : item,
      ),
    );
  };

  // const handleSettingsSave = () => {
  //   setSettingsData(settingsDataTemp);
  //   handleSettingsClose();
  // };

  const getSystemConfigurationById = async (configurationId: string) => {
    let params = new URLSearchParams();
    let configurationDetail: any = null;
    params.append("systemConfigurationId", configurationId?.toString() ?? "0");
    params.append("consumerId", userContext.consumerId.toString());
    params.append("organizationId", userContext.organizationId.toString());
    params.append("branchId", userContext.branchId.toString());
    params.append("departmentId", userContext.departmentId.toString());
    params.append("specialityId", userContext.specialityId.toString());
    try {
      const result: any = await GetSystemConfigurationById(params);
      if (result?.data?.data) {
        configurationDetail = result.data.data;
      }
      return configurationDetail;
    } catch (e: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
  };

  const configReport = useMemo(() => {
    return userContext?.systemConfigurationColl?.find(
      (item) =>
        item?.configModule === "PROCEDURE" &&
        item?.configKey === "PROCEDURE_CONFIG",
    );
  }, [userContext?.systemConfigurationColl]);

  const reportConfigList = useMemo(() => {
    return (
      userContext?.systemConfigurationDetailColl?.filter(
        (item) => item?.configModule === "PROCEDURE",
      ) || []
    );
  }, [userContext?.systemConfigurationDetailColl]);

  const [reportConfigDetail, setReportConfigDetail] = useState<
    ReportConfigItem[]
  >([]);
  const [reportConfigData, setReportConfigData] = useState<ReportConfigItem[]>(
    [],
  );

  const handleSettingsSave = async () => {
    try {
      if ((configReport?.systemConfigurationDefaultId ?? 0) > 0) {
        const reportConfigDetailColl = reportConfigData?.map((config: any) => {
          if (config?.systemConfigurationDetailId > 0) {
            config.mode = "U";
          } else {
            config.mode = "I";
          }
          config.configValue = config.isChecked ? "1" : "0";
          return config;
        });

        let result: any = "";
        let formData = {
          systemConfigurationId: configReport?.systemConfigurationId || 0,
          systemConfigurationDefaultId:
            configReport?.systemConfigurationDefaultId || 0,
          consumerId: userContext?.consumerId,
          organizationId: userContext?.organizationId,
          branchId: userContext?.branchId,
          departmentId: null,
          specialityId: null,
          userId: userContext?.loginDetail.userId || 0,
          isDeleted: configReport?.isDeleted || false,
          dataManagedBy: userContext?.loginDetail.userId || 0,
          configModule: configReport?.configModule || "",
          configValue: configReport?.configValue || "",
          configKeyLabel: null,
          configKey: configReport?.configKey || "",
          configDataType: configReport?.configDataType || "",
          systemConfigurationDetailJson: JSON.stringify(reportConfigDetailColl),
        };

        if ((configReport?.systemConfigurationId ?? 0) > 0) {
          result = await UpdateConfiguration(formData);
        } else {
          result = await CreateConfiguration(formData);
        }

        if (result?.data) {
          const updatedConfig = await getSystemConfigurationById(
            result?.data?.systemConfigurationId || 0,
          );
          setReportConfigDetail(reportConfigData);
          setAnchorEl({ target: null, for: "" });

          let systemConfigurationColl =
            userContext?.systemConfigurationColl?.map((item) => {
              if (
                item?.configModule === updatedConfig?.configModule &&
                item.configKey === updatedConfig?.configKey
              ) {
                return {
                  ...item,
                  systemConfigurationId: updatedConfig.systemConfigurationId,
                  configKeyLabel: updatedConfig.configKeyLabel,
                  configValue: updatedConfig.configValue,
                };
              }
              return item;
            });

          let systemConfigurationDetailColl =
            userContext?.systemConfigurationDetailColl?.map((detailItem) => {
              const match = updatedConfig?.systemConfigurationDetailColl?.find(
                (item: any) =>
                  item?.configModule === detailItem?.configModule &&
                  item?.configKey === detailItem?.configKey,
              );
              if (match) {
                return {
                  ...detailItem,
                  systemConfigurationId: match.systemConfigurationId,
                  systemConfigurationDetailId:
                    match.systemConfigurationDetailId,
                  systemConfigurationDefaultId:
                    match.systemConfigurationDefaultId,
                  configKeyLabel: match.configKeyLabel,
                  configValue: match.configValue,
                };
              }
              return detailItem;
            });

          updateUserContext({
            ...userContext,
            isAlert: true,
            alertMessage: result?.message,
            alertType: AlertType.Success,
            systemConfigurationColl: systemConfigurationColl,
            systemConfigurationDetailColl: systemConfigurationDetailColl,
          });
        }
      } else {
        updateUserContext({
          ...userContext,
          isAlert: true,
          alertMessage: "Something went wrong.",
          alertType: AlertType.Error,
        });
      }
    } catch (e: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
  };

  const fetchData = async () => {
    try {
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const configData = reportConfigList?.map((item) => {
      return { ...item, isChecked: item?.configValue === "1" };
    });
    setReportConfigDetail(configData);
    setReportConfigData(configData);
  }, [reportConfigList]);

  useEffect(() => {
    setIsLoading(true);
    fetchData();
  }, []);

  return (
    <Box
      sx={{
        width: "100%",
      }}
    >
      <Box
        className={"main-container"}
        sx={{
          width: "100%",
          maxWidth: 900,
          mx: "auto",
        }}
      >
        {/* Breadcrumb / Header */}
        {isForPopUp === false && (
          <>
            <Box>
              <Grid container spacing={2} className="page-header">
                <Grid item xs={6} sm={6} md={6}>
                  <Box
                    sx={{
                      display: "flex",
                      height: "100%",
                      alignItems: "center",
                    }}
                  >
                    <CustomBreadcrumbs />
                  </Box>
                </Grid>
                <Grid
                  item
                  xs={6}
                  sm={6}
                  md={6}
                  sx={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Box
                    className="page-header-icon"
                    sx={{
                      paddingRight: "8px",
                      justifyContent: "flex-end",
                      display: "flex",
                    }}
                  >
                    <Button
                      color="primary"
                      variant="outlined"
                      type="button"
                      className="secondary-button"
                      startIcon={<ArrowBackIcon />}
                      onClick={handleBack}
                    >
                      Back
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </>
        )}

        {/* Card */}
        <Box
          sx={{
            background: "#fff",
            borderRadius: 2,
            p: 3,
            boxShadow: "0px 2px 10px rgba(0,0,0,0.08)",
            position: "relative",
          }}
        >
          {/* Tabs */}
          <Grid container alignItems="center" spacing={1} mb={2}>
            {/* Tabs */}
            <Grid item xs={12} sm={11} md={11}>
              <Tabs
                value={param.tabType}
                onChange={handleTabChange}
                TabIndicatorProps={{ style: { display: "none" } }}
                sx={{
                  borderRadius: "10px",
                  width: { xs: "100%", sm: "fit-content" },
                  "& .MuiTabs-flexContainer": {
                    gap: "8px",
                  },
                  "& .MuiTab-root": {
                    borderRadius: "8px",
                  },
                }}
              >
                {(!urlProcedureId || currTabType === 0) && (
                  <Tab
                    label="Single Visit"
                    sx={{
                      textTransform: "none",
                      fontSize: "15px",
                      minHeight: 40,
                      minWidth: 108,
                      px: 2.5,
                      border:
                        param.tabType === 0
                          ? "1px solid #2F67F6"
                          : "1px solid #D6DEE8",
                      bgcolor: param.tabType === 0 ? "#2F67F6" : "#FFFFFF",
                      color: param.tabType === 0 ? "#fff" : "#0009",
                      "&.Mui-selected": {
                        color: "#fff",
                      },
                      "&:hover": {
                        bgcolor: param.tabType === 0 ? "#2F67F6" : "#F8FAFC",
                      },
                    }}
                  />
                )}
                {!addToExistingMultiple && (!urlProcedureId || currTabType === 1) && (
                  <Tab
                    label="Multiple Visit"
                    sx={{
                      textTransform: "none",
                      fontSize: "15px",
                      minHeight: 40,
                      minWidth: 118,
                      px: 2.5,
                      border:
                        param.tabType === 1
                          ? "1px solid #2F67F6"
                          : "1px solid #D6DEE8",
                      bgcolor: param.tabType === 1 ? "#2F67F6" : "#FFFFFF",
                      color: param.tabType === 1 ? "#fff" : "#0009",
                      "&.Mui-selected": {
                        color: "#fff",
                      },
                      "&:hover": {
                        bgcolor: param.tabType === 1 ? "#2F67F6" : "#F8FAFC",
                      },
                    }}
                  />
                )}
                {(!urlProcedureId || currTabType === 2) && (
                  <Tab
                    label="Sub Visit"
                    sx={{
                      textTransform: "none",
                      fontSize: "15px",
                      minHeight: 40,
                      minWidth: 118,
                      px: 2.5,
                      border:
                        param.tabType === 2
                          ? "1px solid #2F67F6"
                          : "1px solid #D6DEE8",
                      bgcolor: param.tabType === 2 ? "#2F67F6" : "#FFFFFF",
                      color: param.tabType === 2 ? "#fff" : "#0009",
                      "&.Mui-selected": {
                        color: "#fff",
                      },
                      "&:hover": {
                        bgcolor: param.tabType === 2 ? "#2F67F6" : "#F8FAFC",
                      },
                    }}
                  />
                )}
              </Tabs>
            </Grid>

            {/* Settings Icon */}
            {!isForPopUp && (
              <Grid item xs={12} sm={1} md={1}>
                <Tooltip title="Settings">
                  <IconButton
                    onClick={(e) => handleSettingsOpen(e, "STATIC_SETTINGS")}
                  >
                    <SettingsIcon />
                  </IconButton>
                </Tooltip>

                <Menu
                  anchorEl={anchorEl.target}
                  open={
                    Boolean(anchorEl.target) &&
                    anchorEl.for === "STATIC_SETTINGS"
                  }
                  onClose={handleSettingsClose}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  PaperProps={{
                    sx: {
                      maxHeight: 380,
                      overflowY: "auto",
                      width: 300,
                      borderRadius: 2,
                    },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: "#f1f5f9",
                        color: "#334155",
                        px: 1.5,
                        py: 1,
                        fontWeight: 700,
                        position: "sticky",
                        top: 0,
                        zIndex: 1,
                      }}
                    >
                      Settings
                    </Box>

                    <Box sx={{ py: 0.5 }}>
                      {reportConfigData.map((item, index) => (
                        <MenuItem
                          key={`${item.configKey || "CONFIG"}-${index}`}
                          sx={{ alignItems: "flex-start" }}
                          onClick={() => handleToggleReportConfig(index)}
                        >
                          <Checkbox
                            checked={Boolean(item.isChecked)}
                            sx={{ p: 0, mr: 1 }}
                          />
                          <Typography sx={{ fontSize: "13px !important" }}>
                            {item?.configKeyLabel || item?.configKey}
                          </Typography>
                        </MenuItem>
                      ))}
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: 1,
                        borderTop: "1px solid #e2e8f0",
                        px: 1.5,
                        py: 1,
                        position: "sticky",
                        bottom: 0,
                        background: "#fff",
                      }}
                    >
                      <Button
                        size="small"
                        color="primary"
                        variant="contained"
                        onClick={handleSettingsSave}
                      >
                        Save
                      </Button>
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={handleSettingsClose}
                      >
                        Close
                      </Button>
                    </Box>
                  </Box>
                </Menu>
              </Grid>
            )}
          </Grid>
          {/* Tab Content */}
          {param.tabType === 0 && (
            <SingleProcedureVisit
              isFieldEnabled={isFieldEnabled}
              isForPopUp={isForPopUp}
              isMemberProcedure={isMemberProcedure}
              memberProcedureData={memberProcedureData}
              handleClosePopUp={handleClosePopUp}
              procedureNames={procedureName}
            />
          )}
          {param.tabType === 1 && (
            <MultipleProcedureVisit
              isFieldEnabled={isFieldEnabled}
              isForPopUp={isForPopUp}
              isMemberProcedure={isMemberProcedure}
              memberProcedureData={memberProcedureData}
              handleClosePopUp={handleClosePopUp}
              procedureNames={procedureName}
            />
          )}
          {param.tabType === 2 && (
            <SubProcedureVisit
              isFieldEnabled={isFieldEnabled}
              isForPopUp={isForPopUp}
              isMemberProcedure={isMemberProcedure}
              memberProcedureData={memberProcedureData}
              handleClosePopUp={handleClosePopUp}
              procedureNames={procedureName}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
};
export default ProcedureSave;
